module.exports = "<!--日期选择-->\n<input placeholder=\"日期选择\" type=\"text\" date-picker  init-date=\"null\" ng-model=\"datePickValue1\">";